// src/features/rooms/services/rooms.js
import { apiClient } from '../../../services/api/client';

export const roomsAPI = {
  // Create room
  createRoom: (data) => 
    apiClient.post('/api/v1/rooms-equipment/rooms/', data),
  
  // Get room by ID
  getRoomById: (roomId) => 
    apiClient.get(`/api/v1/rooms-equipment/rooms/${roomId}`),
  
  // List rooms by department
  listRoomsByDepartment: (departmentId, params = {}) => 
    apiClient.get(`/api/v1/rooms-equipment/rooms/department/${departmentId}`, { params }),
  
  // Update room
  updateRoom: (roomId, data) => 
    apiClient.put(`/api/v1/rooms-equipment/rooms/${roomId}`, data),
  
  // Deactivate room
  deactivateRoom: (roomId, data) => 
    apiClient.post(`/api/v1/rooms-equipment/rooms/${roomId}/deactivate`, data),
  
  // Reactivate room
  reactivateRoom: (roomId) => 
    apiClient.post(`/api/v1/rooms-equipment/rooms/${roomId}/reactivate`),
  
  // Delete room
  deleteRoom: (roomId) => 
    apiClient.delete(`/api/v1/rooms-equipment/rooms/${roomId}`),
};